import {
  Card,
  Group,
  ActionIcon,
  BackgroundImage,
  Checkbox,
  Box,
  Badge,
} from "@mantine/core";
import { IconDownload, IconTrash } from "@tabler/icons-react";
import { useState } from "react";
import { useHover, useMediaQuery } from "@mantine/hooks";
import ResultFeedback from "../_Common/ResultFeedback";

export function GalleryImageCard({
  image,
  onClick,
  onDelete,
  checked,
  onCheckedChange,
  selectionMode,
  mah = 400,
}) {
  const [isDeleting, setIsDeleting] = useState(false);
  const { hovered, ref } = useHover();
  const isMobile = useMediaQuery("(max-width: 50em)");

  var imageUri = image?.pixelImages?.find(
    (img) => img.type === "Thumbnail"
  )?.uri;
  var fullsizeUri = image?.pixelImages?.find(
    (img) => img.type === "Original"
  )?.uri;

  return (
    <Card
      withBorder
      shadow="sm"
      radius="md"
      onClick={() => {
        selectionMode ? false : onClick();
      }}
      style={{ cursor: "pointer" }}
      ref={ref}
    >
      <Card.Section>
        <BackgroundImage src={imageUri} radius="sm">
          <Box mah={mah} style={{ height: `${mah}px` }}>
            {image?.pluginTitle ? (
              <Group
                gap={6}
                style={{ top: 8, left: 8, position: "absolute" }}
                onClick={(e) => e.stopPropagation()}
              >
                <Badge size="sm" radius="sm" color="dark" variant="filled">
                  {image.pluginTitle}
                </Badge>
                {image?.pluginFilterLabel ? (
                  <Badge size="sm" radius="sm" color="grape" variant="filled">
                    {image.pluginFilterLabel}
                  </Badge>
                ) : null}
              </Group>
            ) : null}
            {selectionMode || isMobile || hovered ? (
              <Group
                justify="space-between"
                style={{ bottom: 0, position: "absolute", width: "100%" }}
                bg="rgba(0.5,0.5,0.5,0.7)"
                p="xs"
                onClick={(e) => e.stopPropagation()}
              >
                <Checkbox
                  checked={checked}
                  onChange={(event) =>
                    onCheckedChange(event.currentTarget.checked)
                  }
                  radius="xl"
                  size="md"
                />
                <Group gap="sm">
                  <ResultFeedback
                    logicalImageId={image.logicalImageId}
                    size={isMobile ? "lg" : "md"}
                  />
                  <ActionIcon
                    variant="outline"
                    size={isMobile ? "lg" : "md"}
                    aria-label="Delete"
                    loading={isDeleting}
                    onClick={() => {
                      setIsDeleting(true);
                      onDelete(image.logicalImageId);
                    }}
                  >
                    <IconTrash size={18} />
                  </ActionIcon>

                  <ActionIcon
                    component="a"
                    variant="outline"
                    size={isMobile ? "lg" : "md"}
                    target="_blank"
                    href={fullsizeUri}
                    aria-label="Download"
                  >
                    <IconDownload size={18} />
                  </ActionIcon>
                </Group>
              </Group>
            ) : null}
          </Box>
        </BackgroundImage>
      </Card.Section>
    </Card>
  );
}
